/** Maps app locale (`getCurrentLocale`) to date-fns locale + BCP-47 tag. */
import { format } from 'date-fns';
import { enUS, nl } from 'date-fns/locale';
import { getCurrentLocale } from './useT';

/**
 * @returns {import('date-fns').Locale}
 */
export function getDateFnsLocale() {
  return getCurrentLocale() === 'en' ? enUS : nl;
}

/**
 * BCP-47 tag for `toLocaleDateString` / `Intl`.
 * @returns {'en-US' | 'nl-NL'}
 */
export function getBcp47Tag() {
  return getCurrentLocale() === 'en' ? 'en-US' : 'nl-NL';
}

/**
 * Short weekday pattern: EN "Sun", NL "zo" (match existing UI density).
 * @returns {string}
 */
export function getShortWeekdayPattern() {
  return getCurrentLocale() === 'en' ? 'EEE' : 'EEEEEE';
}

/** NL date-fns month abbreviations often end with "." — strip for UI consistency. */
export function stripDateFnsTrailingPeriod(s) {
  return s.replace(/\.$/, '');
}

/**
 * Short month label for planning cells ("okt", "Oct") without trailing period.
 * @param {Date} date
 * @returns {string}
 */
export function formatShortMonthAbbrev(date) {
  return stripDateFnsTrailingPeriod(
    format(date, 'MMM', { locale: getDateFnsLocale() }),
  );
}
